/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Freizeithobbies1Inputs */

const en__field_freizeithobbies1 = /** @type {(inputs: _Field_Freizeithobbies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hobbies`)
};

const de__field_freizeithobbies1 = /** @type {(inputs: _Field_Freizeithobbies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freizeit/Hobbies`)
};

/**
* | output |
* | --- |
* | "Hobbies" |
*
* @param {_Field_Freizeithobbies1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_freizeithobbies1 = /** @type {((inputs?: _Field_Freizeithobbies1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Freizeithobbies1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_freizeithobbies1(inputs)
	return de__field_freizeithobbies1(inputs)
});
export { _field_freizeithobbies1 as "_field_freizeitHobbies" }